export const TopNavigation = {
  data: [
    {
      icon: 'face',
      title: 'User Profile',
      rbac: 'admin',
      submenu: [{ icon: 'person', title: 'Profile', rbac: 'admin' }]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/json/navigation_json.js